import { render } from "./AdminAttendance.vue?vue&type=template&id=8824cb2c&scoped=true"
import script from "./AdminAttendance.vue?vue&type=script&lang=js"
export * from "./AdminAttendance.vue?vue&type=script&lang=js"

import "./AdminAttendance.vue?vue&type=style&index=0&id=8824cb2c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8824cb2c"]])

export default __exports__